import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46365dcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-2 gap-4"
}
const _hoisted_3 = { class: "name text-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome", -1))
const _hoisted_5 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_6 = { class: "surname text-input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Cognome", -1))
const _hoisted_8 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_9 = { class: "phone text-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Numero di telefono", -1))
const _hoisted_11 = {
  key: 1,
  class: "permissions mt-6"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold inline-block" }, "Permessi", -1))
const _hoisted_13 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_14 = { class: "email text-input" }
const _hoisted_15 = { class: "select" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "role" }, "Livello accesso piattaforma", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "select-description self-center -mb-6"
}
const _hoisted_19 = {
  key: 1,
  class: "select-description self-center -mb-6"
}
const _hoisted_20 = {
  key: 2,
  class: "select-description self-center -mb-6"
}
const _hoisted_21 = {
  key: 3,
  class: "select-description self-center -mb-6"
}
const _hoisted_22 = {
  key: 2,
  class: "credentials mt-6"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold inline-block pb-4" }, "Credenziali app", -1))
const _hoisted_24 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 pb-4"
}
const _hoisted_25 = { class: "surname text-input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isEnabled" }, "Abilita accesso", -1))
const _hoisted_27 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_28 = { class: "email text-input" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_30 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_31 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_32 = { class: "password text-input" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_34 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_35 = {
  key: 1,
  class: "font-light text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
    ]),
    h2: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.subtitle), 1)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-white text-primary-900 undo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Annulla")
        ]),
        _: 1
      }),
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainAction()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.actionTitle), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.mode != _ctx.EditUserModalDialogMode.editEmployeeCredentials)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.user.name.$error }]),
                  id: "name",
                  type: "text",
                  placeholder: "Nome",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.name) = $event)),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.user.name.$touch && _ctx.v$.user.name.$touch(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.user.name]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.name.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_5, "È necessario inserire il nome del dipendente."))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.user.surname.$error }]),
                  id: "surname",
                  type: "text",
                  placeholder: "Cognome",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.surname) = $event)),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.user.surname.$touch && _ctx.v$.user.surname.$touch(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.user.surname]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.surname.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_8, "È necessario inserire il cognome del dipendente."))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  class: "bg-primary-50 col-span-2",
                  id: "phone",
                  type: "text",
                  placeholder: "Numero di telefono del dipendente",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.phone) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.user.phone]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == _ctx.EditUserModalDialogMode.addUser || _ctx.mode == _ctx.EditUserModalDialogMode.editUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("select", {
                      class: "input bg-primary-50 border-red-400",
                      id: "role",
                      name: "role",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.role) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableUserRoles, (kv) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: kv[0]
                        }, _toDisplayString(kv[1]), 9, _hoisted_17))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.user.role]
                    ])
                  ])
                ]),
                (_ctx.user.role == _ctx.UserRole.GUEST)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Il ruolo 'ospite' non ha permessi di accedere e gestire dati di questa piattaforma"))
                  : _createCommentVNode("", true),
                (_ctx.user.role == _ctx.UserRole.WORKER)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Il ruolo 'dipendente' ha il permesso di accesso su questa piattaforma e può gestire i dati relativi alle timbrature"))
                  : _createCommentVNode("", true),
                (_ctx.user.role == _ctx.UserRole.ADMIN)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Il ruolo 'amministratore' ha il permesso di accedere su questa piattaforma e può gestire i dati dipendenti, eventi, strumenti, timbrature e cantieri."))
                  : _createCommentVNode("", true),
                (_ctx.user.role == _ctx.UserRole.SUPER_ADMIN)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Il ruolo 'super amministratore' ha tutti i permessi di gestione di questa piattaforma"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode == _ctx.EditUserModalDialogMode.addUser || _ctx.mode == _ctx.EditUserModalDialogMode.addEmployee || _ctx.mode == _ctx.EditUserModalDialogMode.editUser || _ctx.mode == _ctx.EditUserModalDialogMode.editEmployeeCredentials)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _hoisted_23,
              (_ctx.mode == _ctx.EditUserModalDialogMode.addUser || _ctx.mode == _ctx.EditUserModalDialogMode.editUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_Toggle, {
                        class: "inline-block self-center",
                        name: "isEnabled",
                        modelValue: _ctx.user.isEnabled,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.isEnabled) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.user.email.$error }]),
                    id: "email",
                    name: "email",
                    type: "text",
                    placeholder: "email@sultansrl.it",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.email) = $event)),
                    onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.user.email.$touch && _ctx.v$.user.email.$touch(...args)))
                  }, null, 34), [
                    [_vModelText, _ctx.user.email]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.email.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "errors",
                      key: error.$uid
                    }, [
                      (error.$validator == 'email')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_30, "L'email inserita non è valida."))
                        : _createCommentVNode("", true),
                      (error.$validator == 'required')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_31, "È necessario inserire l'email del dipendente."))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.user.password.$error }]),
                    id: "password",
                    type: "password",
                    placeholder: "*********",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.password) = $event)),
                    onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.user.password.$touch && _ctx.v$.user.password.$touch(...args)))
                  }, null, 34), [
                    [_vModelText, _ctx.user.password]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.user.password.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "errors",
                      key: error.$uid
                    }, [
                      (error.$validator == 'required')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_34, "È necessario inserire la password del dipendente."))
                        : _createCommentVNode("", true),
                      (error.$validator == 'minLength')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_35, "La password deve essere lunga almeno 6 caratteri."))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}